export default __webpack_public_path__ + "static/media/academyGirl.a4d01ad3.png";